import { useState } from 'react'
import { Link, Outlet, ScrollRestoration } from 'react-router-dom'
import { Menu } from 'lucide-react'
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { OddLogoHorizontal } from '@/components/common/OddLogoHorizontal'
import { PageTransitionProvider } from '@/context/PageTransitionContext'
import { PageTransitionOverlay } from '@/components/common/PageTransitionOverlay'
import { AdminSidebar } from './AdminSidebar'
import { AdminFooter } from './AdminFooter'

export function AdminLayout() {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <PageTransitionProvider>
      <PageTransitionOverlay />
      <div className="flex min-h-screen bg-background">
        {/* Desktop sidebar — z-50 keeps it above PageTransitionOverlay (z-49) */}
        <div className="hidden md:flex sticky top-0 h-screen z-50">
          <AdminSidebar />
        </div>

        {/* Main column */}
        <div className="flex min-w-0 flex-1 flex-col">
          {/* Mobile top bar */}
          <header className="sticky top-0 z-50 flex h-14 items-center justify-between border-b bg-background px-4 md:hidden">
            <Link to="/admin" className="flex items-center gap-2">
              <OddLogoHorizontal height={24} className="text-foreground" color="currentColor" />
              <span className="border-l border-border pl-2 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
                Admin
              </span>
            </Link>
            <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="sm" aria-label="Open menu">
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="left" className="w-64 p-0">
                <SheetTitle className="sr-only">Admin navigation</SheetTitle>
                <AdminSidebar forceExpanded onNavigate={() => setMobileOpen(false)} />
              </SheetContent>
            </Sheet>
          </header>

          <ScrollRestoration />
          <main className="flex-1">
            <div className="container mx-auto px-4 py-8">
              <Outlet />
            </div>
          </main>
          <AdminFooter />
        </div>
      </div>
    </PageTransitionProvider>
  )
}
